import { render } from "./arrow-forward.vue?vue&type=template&id=65a0966c&ts=true"
import script from "./arrow-forward.vue?vue&type=script&lang=ts"
export * from "./arrow-forward.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/sgumanea/ciena/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__